export default __webpack_public_path__ + "static/media/av1.7f7b85d2.jpg";